export default __webpack_public_path__ + "static/media/homepagenewbanner.ca527ec7.png";